<template>
<div class="openCard">
    <div class="openCard-detail">
        <div class="detail-title">平安银行电子||类户</div>
        <div class="detail-bank">开户行：<span>平安银行北京分行营业部</span></div>
    </div>
    <div class="bank-card">
        <div class="bank-card-img">
            <div class="card-posion">{{formCard.bankAccount}}</div>
        </div>
    </div>
    <div class="check-mine">
        <div class="check-mine-account" @click="checkMyAccount">查看我的账户</div>
    </div>
</div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
    props:{
        	authInfoVo: {
			typeof: Object,
			default: {},
		},
		},
    data(){
        return{
            formCard:{
				bankAccount:"",
				bankShort:"",
			},
            formApply:{
                taskNo:"",

            }
        }
    },
    mounted(){
        this.formApply.taskNo=sessionStorage.getItem("taskNo")
    },
    watch: {
    authInfoVo: {
      handler(old, cur) {
        const {bankAccount, bankShort} = this.authInfoVo
        this.formCard.bankAccount =bankAccount;
        this.formCard.bankShort = bankShort;
      },
      deep: true,
      immediate: true,
    },
  },
    methods:{
        checkMyAccount(){
            if(this.formApply.taskNo){
                this.formApply.redirectDomain = config.topDomainName;
                http.post(config.applyH5,this.formApply).then(({code,data,message})=>{
                    if(code===0){
                        if (data.applyResult===2) {
                          // 跳转到signUrl
                          location.href =data.signUrl
                        } else { // 【0 或 1 的情况】
                          if (data.thirdRedirectUrl) {
                            // 跳转到第三方页面
                            location.href =data.thirdRedirectUrl
                        } else {
                            //  返回到申请成功页面
                            this.$router.push({path:"../../applicationSuccess"})
                        }
                    }
                    }else{
                        this.$toast.fail(message)
                    }
                })
            }else{
                this.$router.push({path:'../updateInfo'})
            }
        }
    }
}
</script>
<style lang="less" scoped>
.openCard{
    margin-top: 50px;
    .openCard-detail{
        .detail-title{
            font-size: 32px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 6px;
        }
        .detail-bank{
          font-size: 26px;
          color: #666666;
        }

    }
    .bank-card{
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 50px 0 70px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .bank-card-img{
           width: 90%;
           height: 400px;
           background: url(../../../assets/img/bank_card.png) no-repeat;
           background-size: contain;
           border-radius: 30px;
           position: relative;
           .card-posion{
               position: absolute;
               bottom: 80px;
               left: 80px;
               color: #ffffff;
               font-size: 34px;
               letter-spacing:8px
           }
        }
    }
    .check-mine{
        width: 100%;
        display: flex;
        justify-content: center;
        .check-mine-account{
            width: 90%;
            height: 90px;
            line-height: 90px;
            background: #0681FD;
            border-radius: 45px;
            color: #ffffff;
            font-size: 34px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/commonInfo/components/openCard.vue